// Only use for work that has not submitted an order or payment.
export const withTimeout = async (operation, milliseconds = 15000) => {
    let timer;
    try {
        return await Promise.race([
            operation,
            new Promise((_, reject) => {
                timer = setTimeout(() => {
                    const error = new Error('Menu option validation timed out');
                    error.code = 'VALIDATION_TIMEOUT';
                    reject(error);
                }, milliseconds);
            }),
        ]);
    } finally {
        clearTimeout(timer);
    }
};
